module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add"},"da":{"add":"Tilføj"}}')
  delete Component.options._Ctor
}
